import { ConsumptionType } from './consumption-type.class';
import { MaterialColor } from './material-color.class';
import { MaterialType } from './material-type.class';
import { Supplier } from './supplier.class';

export class RawMaterial {
    id: number;
    name: string;
    material_type_id?: number;
    material_type?: MaterialType;
    supplier_id?: number;
    supplier?: Supplier;
    color_id?: number;
    color?: MaterialColor;
    od_number?: string;
    consumption?: number;
    consumption_type_id?: number;
    consumption_type?: ConsumptionType;
    certificate_number?: string;
    thickness?: number;
    width?: number;
    coverage_rate?: number;
    optional?: boolean;
    created_at: Date;
    updated_at: Date;
    deleted_at?: Date;

    pivot?: {
        id?: number;
        material_id?: number;
        raw_material_id?: number;
        entity_id?: number;
        optional?: number;
        consumption?: number;
        width?: number;
        thickness?: number;
        coverage_rate?: number;
        deleted_at?: Date;
        created_at?: Date;
        updated_at?: Date;
    };
}
